import React from 'react';
interface LawVoLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function LawVoLogo({
  size = 'md',
  className = ''
}: LawVoLogoProps) {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16'
  };
  return <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/ghdcimjrseasalrbdpdvmn/8eacedf8-3bc8-487a-ae9f-488e5785c26e/logo.png" alt="LawVo" className={`${sizeClasses[size]} ${className}`} data-id="element-149" />;
}